import React from 'react'
import online from './static/online.svg';
import offline from './static/offline.svg';
import busy from './static/busy.svg';
import away from './static/away.svg';
import company from './static/company.svg';

const bottomStatusIcons = {
    online,
    offline,
    busy,
    away,
    company,
};

function BottomStatus({ bottomStatus, size }) {
    const iconSrc = bottomStatusIcons[bottomStatus];
    return (
        <div className={`pgn__avatar-bottom-status-${size}`}>
            <img className={`pgn__avatar-bottom-status-icon-${size}`} src={iconSrc} alt="" />
        </div>
    )
}

export default BottomStatus